import React, { useRef } from "react";
import "../../Assets/Css/Transaction.scss";
import Table from "../../Components/Table";
import Invoicefilter from "../../Components/Invoice-filter";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import qs from "query-string";
import { getAllTransactions, importCSV } from "../../Services/Transactions/action";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import moment from "moment";


const Transaction = (props) => {
  const [params, setParams] = useState({});
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [checked, setChecked] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  let count = props.transactionsList?.length;
  const fileInputRef = useRef(null);
  const modalRef = useRef(null);


  useEffect(() => {
    fetchTransactionList();
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setFileName('');
    setSelectedFile(null);
    fileInputRef.current.value = null;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;

      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);


  const setTheData = async () => {
    try {
      await props.transactionsList && setTransactions(await props.transactionsList.map((transaction) => {
        const shareHolder = new Set();
        const Invoices = new Set();
        const Spends = new Set();
        const { amount: transactionAmount } = transaction;
        let distrubutedAmount = 0;

        transaction?.transactionShareHolderMap?.map(tranShalehoder => {
          distrubutedAmount += parseFloat(tranShalehoder?.amount);
          shareHolder.add(JSON.stringify({ ...tranShalehoder?.shareHolderTransactionMap, tranShId: tranShalehoder.id, transAmount: tranShalehoder.amount }));
        })
        transaction?.transactionInvoiceMap?.map(tranInvoice => {
          Invoices.add(JSON.stringify({ ...tranInvoice?.invoiceTransactionMap, tranShId: tranInvoice.id, transInvoiceAmount: tranInvoice.amount }));
        })
        transaction?.transactionSpendMap?.map(tranSpend => {
          Spends.add(JSON.stringify({ ...tranSpend?.spendTransactionMap, tranShId: tranSpend.id, transSpendAmount: tranSpend.amount }));
        })

        const transactionType = transaction?.type === "credit" ? "Credited" : "Debited"
        const allPaymentDistributed = parseFloat(transactionAmount) === distrubutedAmount ? true : false;
        return {
          Type: {
            value: transactionType || '',
            type: transaction?.type
          },
          Amount: {
            value: `₹${transaction?.amount}` || '',
            type: "amount"
          },
          Description: {
            value: transaction?.description || '',
            type: "description"
          },
          "Share Holders": {
            value: Array.from(shareHolder).map(item => {
              item = JSON.parse(item);
              return { name: item.name, id: item.id, amount: item.transAmount }
            }),
            type: "share holder"
          },
          Invoices: {
            value: Array.from(Invoices).map(item => {
              item = JSON.parse(item);
              return { name: item.title, id: item.id, amount: item.transInvoiceAmount }
            }),
            type: 'invoices'
          },
          Action: {
            value: '/transaction/edit',
            value2: '/transaction/view',
            type: 'action'
          },
          Transaction_Date: {
            value: moment(transaction?.transaction_date).format('DD/MM/YYYY') || null, //transaction?.transaction_date.split(' ')[0] || null,
            type: "date"

          },
          transactionId: {
            value: transaction.id,
          },
          spendList: {
            value: Array.from(Spends).map(item => {
              item = JSON.parse(item);
              return { name: item.name, id: item.id, amount: item.transSpendAmount }
            }),
          },
          allPaymentDistributed
        }
      }));
    } catch (error) {
      console.error("Error Setting Transaction:", error);
      toast.error("Error : ", error);
    }
  }

  useEffect(() => {
    setTheData();
  }, [props.transactionsList]);

  const fetchTransactionList = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props.getAllTransactions(location.search);
      setTheData();
    } catch (error) {
      console.error("Error fetching Transaction:", error);
      toast.error("Error : ", error);
    }
  }


  const handleFileChange = (event) => {
    const f = event.target.files[0];
    setSelectedFile(f);
    if (f) {
      setFileName(f.name);
    } else {
      setFileName('');
    }
  }


  const handleImportClick = async (event) => {
    try {
      setLoading(true);


      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const csvData = e.target.result;
          await props.importCSV(selectedFile, csvData);
          setLoading(false);
          fetchTransactionList();
          setFileName('');
          setSelectedFile(null);
          fileInputRef.current.value = null;
        } catch (error) {
          setHasError(true);
          console.error('Error importing transactions:', error);
          toast.error('Error importing transactions:', error.message);
        }
      };

      reader.readAsText(selectedFile);

    } catch (error) {
      setHasError(true);
      console.error('Error importing transactions:', error);
      toast.error('Error importing transactions:', error.message);
    }
  };

  useEffect(() => {
    fetchTransactionList();
  }, [location.search]);

  const header = [
    // { field: 'checkbox' },
    { field: 'Type' },
    { field: 'Amount' },
    { field: 'Description' },
    { field: 'Share Holders' },
    { field: 'Invoices' },
    { field: 'Transaction_Date' },
    { field: 'Action' },

  ];

  let footer = true;

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  useEffect(() => {
    setParams(qs.parse(location.search, { ignoreQueryPrefix: true }))
  }, [location.search]);

  const handleChange = (e) => {
    if (e[1] == "headerAll" && e[0] === true) {
      setTotalSelectedIds([...e[2]]);
    } else if (e[0] === true && e[1] !== "headerAll") {
      setTotalSelectedIds([...totalSelectedIds, e[1]]);
    } else if (e[1] == "headerAll" && e[0] === false) {
      setTotalSelectedIds([]);
    } else {
      let filterdId = totalSelectedIds.filter((item) => {
        return item != e[1];
      });
      setTotalSelectedIds(filterdId);
    }
  };



  return (
      <div className="main-transaction">
        <div className="page-title">
          <h4>Transaction</h4>
          <div className="edit-btn">
            <button type="button" disabled={props.loading} className="custom-btn" style={{ marginRight: "5px" }}>
              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <Link to='/transaction/ShareDistribution' style={{ textDecoration: "inherit", color: "inherit" }}>Share-Distribution</Link>}
            </button>
            <button type="button" disabled={props.loading} onClick={() => setShowModal(true)} className="custom-btn" style={{ position: 'relative', marginRight: "5px" }}>
              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <Link to='/transaction' style={{ textDecoration: "inherit", color: "inherit" }}></Link>}
              Upload
            </button>
            <button type="button" disabled={props.loading} className="custom-btn">
              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> :
                <Link to='/transaction/add' style={{ textDecoration: "inherit", color: "inherit" }}>Add</Link>
              }
            </button>
          </div>
        </div>

        {showModal && (
          <div className="modal show" tabIndex="-1" role="dialog" style={{ display: 'block', marginTop: '120px', marginLeft: '500px' }}>
            <div className="modal-dialog" role="document">
              <div className="modal-content" ref={modalRef}>

                <div className="modal-header" style={{ display: 'flex' }}>
                  <h5 className="modal-title">Upload File</h5>

                </div>
                <div className="modal-body" style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>

                    <input
                      type="file"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      ref={fileInputRef}
                    />
                    <Button onClick={() => fileInputRef.current.click()}>
                      Choose File
                    </Button>

                    <div style={{ marginLeft: '10px' }}>{fileName ? fileName : 'No File Selected'}</div>
                  </div>
                  {fileName ? <Button type="button" className="close" onClick={() => {
                    setSelectedFile(null);
                    setFileName('');
                    fileInputRef.current.value = null;

                  }} aria-label="Close" style={{ backgroundColor: 'gray', border: 'none' }}>
                    x
                  </Button> : ''}
                </div>

                <div className="modal-footer">
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleImportClick}
                    disabled={loading || !selectedFile}
                  >
                    {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Proceed'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="filter-part">
          <Invoicefilter filter={params} />
        </div>
        <div className="transaction-table-part">
          <Table
            header={header}
            data={transactions}
            footer={footer}
            count={count}
            handleChange={handleChange}
            checked={checked}
            totalSelectedIds={totalSelectedIds}
            defaultParams={params}
            loading={props.loading}
            records={parseFloat(props.records)}
          />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.transactionReducers.loading,
    transactionsList: state.transactionReducers.transactions.rows,
    count: state.transactionReducers.transactions.count,
    records: state.transactionReducers.transactions.noOfRecords
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getAllTransactions: (params) => {
      dispatch(getAllTransactions(params))
    },
    importCSV: (selectedFile, csvData) => {
      dispatch(importCSV(selectedFile, csvData))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
